// extracted by mini-css-extract-plugin
export default {"specialEventsCardImg":"SpecialEventsSection_specialEventsCardImg__oB8XL","specialEventsCardImgScaleddown":"SpecialEventsSection_specialEventsCardImgScaleddown__9aWEp"};